export default __webpack_public_path__ + "static/media/wideend.a5c2b31b.png";